import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeReward  {
    _originalTypeClassName = "zERP.BO.EmployeeReward";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeReward.translate = translateService;
}
this.Files = [];
this.RewardMotives = [];
this.Id = null;
this.PresentationDate = null;
this.UpdatesPayroll = false;
this.Notes = null;
this.Name = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
PresentationDate:any;
UpdatesPayroll:any;
Notes:any;
Name:any;
Files:any;
Winner:any;
RewardMotives:any;
Reward:any;
Presenter:any;
static setFiles = ($this, items) => {
                if (items == null) items = [];
                if ($this.Files == null) $this.Files = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Files.length > 0) {
                    Domain.EmployeeReward.removeFiles($this, $this.Files[0]);
                }

                Domain.EmployeeReward.addManyFiles($this, copyItems);
            }
static addManyFiles = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeReward.addFiles($this, items[i]);
                }
            }
static addFiles = ($this, item) => {
                if ($this.Files == null) $this.Files = [];
                if (item == null || $this.Files.indexOf(item) > -1) return;
                $this.Files.push(item);
}
static addRangeFiles = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeReward.addFiles($this, item));
            }
static removeFiles = ($this, item) => {
                if ($this == null || $this.Files == null || $this.Files.indexOf(item) === -1) return;
                var _index = $this.Files.indexOf(item);
                $this.Files.splice(_index, 1);
}
static clearFiles = ($this) => { $this.Files = null; }
static setWinner = ($this, value) => {
var oldValue = $this.Winner;
$this.Winner = value;
if (value != null) {
}
}
static setRewardMotives = ($this, items) => {
                if (items == null) items = [];
                if ($this.RewardMotives == null) $this.RewardMotives = [];

                const copyItems = Common.cloneObject(items);

                while ($this.RewardMotives.length > 0) {
                    Domain.EmployeeReward.removeRewardMotives($this, $this.RewardMotives[0]);
                }

                Domain.EmployeeReward.addManyRewardMotives($this, copyItems);
            }
static addManyRewardMotives = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeReward.addRewardMotives($this, items[i]);
                }
            }
static addRewardMotives = ($this, item) => {
                if ($this.RewardMotives == null) $this.RewardMotives = [];
                if (item == null || $this.RewardMotives.indexOf(item) > -1) return;
                $this.RewardMotives.push(item);
}
static addRangeRewardMotives = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeReward.addRewardMotives($this, item));
            }
static removeRewardMotives = ($this, item) => {
                if ($this == null || $this.RewardMotives == null || $this.RewardMotives.indexOf(item) === -1) return;
                var _index = $this.RewardMotives.indexOf(item);
                $this.RewardMotives.splice(_index, 1);
}
static clearRewardMotives = ($this) => { $this.RewardMotives = null; }
static setReward = ($this, value) => {
var oldValue = $this.Reward;
$this.Reward = value;
if (value != null) {
}
}
static setPresenter = ($this, value) => {
var oldValue = $this.Presenter;
$this.Presenter = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}